import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import Vue from 'vue'

// initial state
const state = {
  einstellungen: [],
  veranstaltungen: [],
  loading: false,
  loaded: false,
  error: null
}

// getters
const getters = {
  veranstaltung: (state) => (id) => {
    return state.veranstaltungen.find(bbr => bbr.id === id)
  },
  einstellung: (state) => (id) => {
    switch (id) {
      case 'kalender':
        let kalender = state.einstellungen.find(einstellung => einstellung.id === 'kalender')
        if (kalender) {
          kalender = Object.values(kalender)
          kalender = kalender.filter(kal => kal.isPublic === true)
        }
        return kalender

      case 'alleKalender':
        return Object.values(state.einstellungen.find(einstellung => einstellung.id === 'kalender'))

      default:
        return state.einstellungen.find(einstellung => einstellung.id === id)
    }
  },
  nachsteVeranstaltungen: (state) => {
    let today = new Date().toISOString().substr(0, 10)
    let veranstaltungen = []
    state.veranstaltungen.forEach(item => {
      if (today <= item.vonDatum) {
        veranstaltungen.push(item)
      }
    })
    return veranstaltungen
  },
  vergangeneVeranstaltungen: (state) => {
    let today = new Date().toISOString().substr(0, 10)
    let lastSemester = new Date(new Date().getTime() - (180 * 24 * 60 * 60 * 1000)).toISOString().substr(0, 10)
    let veranstaltungen = []
    state.veranstaltungen.forEach(item => {
      if ((today >= item.vonDatum) && (lastSemester <= item.vonDatum)) {
        veranstaltungen.push(item)
      }
    })
    return veranstaltungen
  },
  loading (state) {
    return state.loading
  },
  error (state) {
    return state.error
  }
}

// actions
const actions = {
  loadVeranstaltungen ({commit}) {
    commit('setLoading', true)
    console.log('Veranstaltungen laden...')
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('veranstaltungen').orderBy('vonDatum').orderBy('vonZeit')
    .onSnapshot(snapshot => {
      const veranstaltungen = []
      snapshot.forEach(doc => {
        veranstaltungen.push({
          ...doc.data(),
          id: doc.id
        })
        commit('setLoadedVeranstaltungen', veranstaltungen)
        commit('setLoading', false)
        commit('setLoaded', true)
      })
    }, (error) => {
      console.log(error)
      commit('setLoading', false)
    })
    commit('setLoading', true)
    console.log('Einstellungen laden...')
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('einstellungen')
    .onSnapshot(snapshot => {
      const einstellungen = []
      snapshot.forEach(doc => {
        einstellungen.push({
          ...doc.data(),
          id: doc.id
        })
        commit('setLoadedEinstellungen', einstellungen)
        commit('setLoading', false)
      })
    }, (error) => {
      console.log(error)
      commit('setLoading', false)
    })
  },
  createVeranstaltung ({commit, getters}, payload) {
    if (payload.anmeldungen === undefined) {
      payload.anmeldungen = []
    }
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('veranstaltungen').add(payload)
      .then(key => {
        commit('updateVeranstaltungIcalFeed')
      })
      .catch((error) => {
        console.log(error)
      })
  // Reach out to firebase and store it
  },
  deleteVeranstaltungData ({commit}, payload) {
    commit('setLoading', true)
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('veranstaltungen').doc(payload).delete()
    .then(() => {
      commit('setLoading', false)
      commit('deleteVeranstaltung', payload)
      commit('updateVeranstaltungIcalFeed')
    })
    .catch(error => {
      console.log(error)
      commit('setLoading', false)
    })
    commit('setLoading', false)
  },
  updateVeranstaltungData ({commit}, payload) {
    commit('setLoading', true)
    const updateObj = {}
    Object.keys(payload).forEach(key => {
      if (payload[key] !== undefined) {
        updateObj[key] = payload[key]
      }
    })
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('veranstaltungen').doc(payload.id).update(updateObj)
    .then(() => {
      commit('setLoading', false)
      commit('updateVeranstaltung', payload)
      commit('updateVeranstaltungIcalFeed')
    })
    .catch(error => {
      console.log(error)
      commit('setLoading', false)
    })
  }
}

// mutations
const mutations = {
  setLoadedVeranstaltungen (state, payload) {
    state.veranstaltungen = payload
  },
  setLoadedEinstellungen (state, payload) {
    state.einstellungen = payload
  },
  createVeranstaltung (state, payload) {
    state.veranstaltungen.push(payload)
  },
  updateVeranstaltung (state, payload) {
    const veranstaltung = state.veranstaltungen.find(veranstaltung => {
      return veranstaltung.id === payload.id
    })
    Object.keys(payload).forEach(key => {
      if (payload[key]) {
        veranstaltung[key] = payload[key]
      }
    })
  },
  updateVeranstaltungIcalFeed (state) {
    const ics = require('ics')
    let eventsByCalendar = {}
    eventsByCalendar['Alle'] = []

    state.veranstaltungen.forEach(item => {
      let a = item.vonDatum.split('-')
      let b = item.vonZeit.split(':')
      let c = item.bisDatum.split('-')
      let d = item.bisZeit.split(':')
      let anmeldungen = item.anmeldungen.length + item.weitereAnmeldungen.length
      let bemerkung = item.bemerkung ? item.bemerkung : ''
      let anmeldungenText = anmeldungen.length > 0 ? '(mindestens ' + anmeldungen + ' Anmeldungen)' : ''
      const event = {
        start: [parseInt(a[0]), parseInt(a[1]), parseInt(a[2]), parseInt(b[0]), parseInt(b[1])],
        end: [parseInt(c[0]), parseInt(c[1]), parseInt(c[2]), parseInt(d[0]), parseInt(d[1])],
        title: item.titel,
        description: bemerkung + ' ' + anmeldungenText,
        location: item.ort,
        calName: item.kalender
      }

      if (!eventsByCalendar[item.kalender]) {
        eventsByCalendar[item.kalender] = []
      }
      eventsByCalendar[item.kalender].push(event)
      let kalender = Object.values(state.einstellungen.find(item => item.id === 'kalender')).filter(kal => kal.isPublic === true)
      kalender.forEach(kal => {
        if (kal.name === item.kalender) {
          eventsByCalendar['Alle'].push(event)
        }
      })
    })

    console.log(eventsByCalendar['Alle'].filter(item => item.title === 'Abschlusskneipe'))

    for (let calendarName in eventsByCalendar) {
      let events = eventsByCalendar[calendarName]
      let icaltext = ics.createEvents(events).value
      let filename = `${calendarName}.ics`
      const storageRef = firebase.storage().ref(`/kalender/${Vue.prototype.$vars.verbindung}/${filename}`)
      let bb = new Blob([icaltext], {type: 'text/calendar'})

      storageRef.put(bb).then(() => {
        console.log(`${filename} updated`)
      }).catch((error) => {
        console.log(error.message)
      })
    }
  },
  deleteVeranstaltung (state, payload) {
    let array = state.veranstaltungen
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === payload) {
        array.splice(i, 1)
      }
    }
    state.veranstaltungen = array
  },
  setLoading (state, payload) {
    state.loading = payload
  },
  setLoaded (state, payload) {
    state.loaded = payload
  },
  setError (state, payload) {
    state.error = payload
  },
  clearError (state) {
    state.error = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/veranstaltungen_alt.js